// extracted by mini-css-extract-plugin
module.exports = {"cardHeader":"styles_cardHeader__NZzuk","cardEven":"styles_cardEven__2qeV4","cardWrapper":"styles_cardWrapper__3LI50"};